<template>
  <div>
    <h1>Registrar origen</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre del origen">
                <a-input ref="name" placeholder="Nombre del origen" v-model="$v.origin.name.$model" />
                <small class="text-danger" v-if="!$v.origin.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredSource($v.origin.name.$model)">Ya existe un registro con este nombre de origen</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Geocerca">
                <v-select label="name" :options="getAllGeofences" v-model="$v.origin.geofence.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.origin.geofence.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredSource($v.origin.name.$model) && !$v.$invalid)" v-if="this.clicked === 0">
                  Registrar
                </button>
                <button class="btn btn-gray px-5"  v-else-if="this.clicked === 1">Cargando...</button>
                <button class="btn btn-success px-5"  v-else-if="this.clicked === 2">Se a registrado exitosamente</button>
                <button class="btn btn-danger px-5"  v-else-if="this.clicked === 3">Ha ocurrido un error</button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const GET_ALL_GEOFENCES = gql`
  query getAllGeofences{
    getAllGeofences{
      id
      name
    }
  }
`
const CREATE_SOURCE = gql`
  mutation createSource($name: String, $geofenceId: Int, $createdBy: String, $active: Int){
    createSource(source: {name: $name geofenceId: $geofenceId createdBy: $createdBy active: $active}){
      id
      name
    }
  }
`
const GET_ALL_SOURCES = gql`
  query getAllSources{
    getAllSources{
      id
      name
      createdBy
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      origin: {
        name: '',
        geofence: null,
      },
      createdBy: this.$store.state.user.email,
      registeredSources: {},
      clicked: 0,
    }
  },
  apollo: {
    getAllGeofences: {
      query: GET_ALL_GEOFENCES,
      result({ data }) {
        // console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllSources: {
      query: GET_ALL_SOURCES,
      context: headers(),
      result({ data }) {
        data.getAllSources.forEach(source => {
          this.registeredSources[source.name] = 1
        })
        // console.log('registeredSources')
        // console.log(this.registeredSources)
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    handleSubmit() {
      if (this.clicked === 0) {
        this.clicked = 1
        this.$apollo.mutate({
          mutation: CREATE_SOURCE,
          variables: {
            name: this.origin.name,
            geofenceId: parseInt(this.origin.geofence.id),
            createdBy: this.createdBy,
          },
          context: headers(),
        })
          .then(data => {
            console.log(data)
            this.clicked = 2
            this.$router.push('/tarifasPlanas/origen')
          })
          .catch(error => {
            this.clicked = 3
            console.log(error)
          })
      }
    },
    validateRegisteredSource(sourceName) {
      if (this.registeredSources[sourceName.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  validations: {
    origin: {
      name: { required },
      geofence: { required },
    },
  },
}
</script>
